<template>
  <b-container class="qrcode-gen mainContent">
    <div>
      <h2 class="mb-4">ลงทะเบียนเสร็จสิ้น</h2>
    </div>
    <b-row align-v="center" align-h="center">
      <b-card

        img-alt="QR Code"
        style="width: 70%; max-width: 30em; max-height: 100%;"
        class=""
      >
        <b-card-body>
          <b-card-text>
            <b-row style="justify-content: center;">
              <img center alt="Center image" :src="qrcode">
            </b-row>
            <b-row>
              <b-col>หมายเลขผู้ลงทะเบียน : {{ this.username }}</b-col>
            </b-row>
            <b-row>
              <b-col>รหัสผ่าน : {{ this.password }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="req-field" style="text-align: center;">
                <p>กรุณาเก็บ หมายเลขผู้ลงทะเบียน, เเละรหัสผ่าน เพื่อใช้ในการเข้าสู่ระบบ, เเละลงทะเบียนเข้าร่วมกิจกรรม</p>
                <p>กรุณาเก็บ หรือ save QR code เพื่อใช้เป็นบัตรผ่าน ในการเข้าร่วมกิจกรรม (ที่หน้าบูทกิจกรรมจะมีการ scan qr code)</p>
              </b-col>
            </b-row>
          </b-card-text>
          <div class="row">
            <div class="col-lg-6 mt-2"><a href="http://openhouse.kmitl.ac.th/2019/" class="btn btn-primary w-100">หน้าหลัก</a></div>
            <div class="col-lg-6 mt-2"><a @click="gotoWorkshop()" class="btn btn-primary">สมัครเข้าร่วมกิจกรรม</a></div>
          </div>


        </b-card-body>
      </b-card>
    </b-row>
  </b-container>
</template>

<script>
import QRcode from "qrcode";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "QRGenerate",
  data: () => {
    return {
      qrcode: "123",
    };
  },
  methods: {
    ...mapGetters([
      'getUsername',
      'getPassword'
    ]),
    ...mapActions([
      'login'
    ]),
    onLoad: function() {
      this.username = this.getUsername()
      this.password = this.getPassword()
      let hostname = "https://oph2019-kmitl-c2dac.firebaseapp.com"
      QRcode.toDataURL(`${hostname}/profile?user=${this.username}&password=${this.password}`)
      .then(url => {
        // console.log(url);
        this.qrcode = url;
      })
      .catch(err => {
        // console.log(err);
      });

      this.login({username: this.username, password: this.password})
    },
    gotoWorkshop() {
      this.$router.push('/workshop')
    }
  },
  computed: {
    username: {
      get() {
        return this.$store.state.profile.username
      },
      set(value) {
        this.$store.commit('setUsername', value)
      }
    },
    password: {
      get() {
        return this.$store.state.profile.password
      },
      set(value) {
        this.$store.commit('setPassword', value)
      }
    }
  },
  mounted() {
    this.onLoad();
  }
};
</script>

<style lang="css" scoped>
.btn-primary {
  color: #fff;
  background-color: #ee4b23;
  border-color: #ee4b23;
}

a:not([href]):not([tabindex]):focus, a:not([href]):not([tabindex]):hover {
    color: rgba(255,255,255,.5);
    text-decoration: none;
    background-color: #ee4b23;
    border-color: #ee4b23;
}

a:not([href]):not([tabindex]) {
    color: #fff;
    text-decoration: none;
}

.req-field {
    color: #ee4b23;
}
.mainContent {
  min-height: calc(100vh - 314px) ;
}
</style>
